import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m386 19.5 1.4 1.5 3.1-3 3.1 3 1.4-1.5-4.5-4.5zm9 14-1.4-1.5-3.1 3-3.1-3-1.4 1.5 4.5 4.5z",
      style: {"fill":"#767676"},
      transform: "translate(-386 -15)"
    }, null, -1)
  ]))]))
}
export default { render: render }